module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_02-1eebf82a9f262f3490b1fe22c521b85e.webp";